import { lazy, Suspense } from "react";
import { RouteLoader } from "../shared/components";

import { ROUTES } from "../shared/utils";

import { ProtectedRoute } from "../shared/pages";
import { AppLayout } from "../shared/layouts";

import { AddPortfolio, Portfolio } from "../features/portfolio";
import { AddProject } from "../features/projects";
import { Task } from "../features/tasks";
import { Queries } from "../features/queries";
import { RiskAndIssues } from "../features/riskAndIssues";
import { Documents } from "../features/artefacts/routes/Documents";
import { Commercials } from "../features/commercials/routes/Commercials";
import { RecurringTasks } from "../features/recurringTasks";
import { MaterialRequests } from "../features/materialRequests";
import { ResourceRequests } from "../features/resourceRequests";

const LiveProgress = lazy(() => import("../features/liveProgress").then((m) => ({ default: m.LiveProgress })));
const ScheduleAndPlanning = lazy(() => import("../features/schedulePlanning").then((m) => ({ default: m.ScheduleAndPlanning})))
const StageGates = lazy(() => import("../features/stageGates/routes/StageGates").then((m) => ({ default: m.StageGates })));
const MeetingManager = lazy(() => import("../features/meetingManager/routes/MeetingManager").then((m) => ({ default: m.MeetingManager })));
const Procurement = lazy(() => import("../features/procurementPipeline").then((m) => ({ default: m.Procurement })));
const Jeopardy = lazy(() => import("../features/jeopardy").then((m) => ({ default: m.Jeopardy })));
const JeopardyDetail = lazy(() => import("../features/jeopardy").then((m) => ({ default: m.JeopardyDetail })));
const ContractorOversight = lazy(() => import("../features/contractorOversight").then((m) => ({ default: m.ContractorOversight })));
const CommercialsDashboard = lazy(() => import("../features/commercialsDashboard").then((m) => ({ default: m.CommercialsDashboard })));
const BudgetCastPerformance = lazy(() => import("../features/budgetCastPerformance").then((m) => ({ default: m.BudgetCastPerformance })));
const TrendsForecast = lazy(() => import("../features/trendsForecast").then((m) => ({ default: m.TrendsForecast })));
const CommitmentsExposure = lazy(() => import("../features/commimentsExposure").then((m) => ({ default: m.CommitmentsExposure })));
const ProgrammeDashboard = lazy(() => import("../features/programmeDashboard").then((m) => ({ default: m.ProgrammeDashboard })));
const Import = lazy(() => import("../features/imports").then((m) => ({ default: m.Import })));
const BatchDetail = lazy(() => import("../features/imports").then((m) => ({ default: m.BatchDetail })));
const Export = lazy(() => import("../features/export").then((m) => ({ default: m.Export })));
const VisionStudio = lazy(() => import("../features/visionStudio").then((m) => ({ default: m.VisionStudio })));
const Projects = lazy(() => import("../features/projects").then((m) => ({ default: m.Projects })));
const ProjectOverviewDashboard = lazy(() => import("../features/projectOverview").then((m) => ({ default: m.Dashboard })));
const Overview = lazy(() => import("../features/projectOverview").then((m) => ({ default: m.Overview })));

export const operationalRoutes = [
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout title="Live Progress" />,
        children: [{ path: ROUTES.LIVE_PROGRESS, element: ( <Suspense fallback={<RouteLoader/>}> <LiveProgress /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Portfolios" />,
        children: [{ path: ROUTES.PORTFOLIO, element: <Portfolio /> }],
      },
      {
        element: <AppLayout title="Add Portfolio" />,
        children: [{ path: ROUTES.ADD_PORTFOLIO, element: <AddPortfolio isEdit={false} /> }]
      },
      {
        element: <AppLayout title="Edit Portfolio" />,
        children: [{ path: ROUTES.EDIT_PORTFOLIO, element: <AddPortfolio isEdit={true} /> }]
      },
      {
        element: <AppLayout title="Portfolio Programme Dashboard" />,
        children: [{ path: ROUTES.PORTFOLIO_PROGRAMME_DASHBOARD, element: ( <Suspense fallback={<RouteLoader/>}> <ProgrammeDashboard /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS, element: ( <Suspense fallback={<RouteLoader/>}> <Projects /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS, element: ( <Suspense fallback={<RouteLoader/>}> <Projects /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_DASHBOARD, element: ( <Suspense fallback={<RouteLoader/>}> <ProjectOverviewDashboard /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_OVERVIEW, element: ( <Suspense fallback={<RouteLoader/>}> <Overview /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_SCHEDULE_AND_PLANNING, element: ( <Suspense fallback={<RouteLoader/>}> <ScheduleAndPlanning /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_STAGE_GATES, element: ( <Suspense fallback={<RouteLoader/>}> <StageGates /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_RECURRING_TASKS, element: <RecurringTasks /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_TASKS, element: <Task /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_QUERIES, element: <Queries /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_RISKS_AND_ISSUES, element: <RiskAndIssues /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_COMMERICIALS, element: <Commercials /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.ADD_PROJECT, element: <AddProject isEdit={false} /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.EDIT_PROJECT, element: <AddProject isEdit={true} /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_DASHBOARD, element: ( <Suspense fallback={<RouteLoader/>}> <ProjectOverviewDashboard /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_OVERVIEW, element: ( <Suspense fallback={<RouteLoader/>}> <Overview /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_SCHEDULE_AND_PLANNING, element: ( <Suspense fallback={<RouteLoader/>}> <ScheduleAndPlanning /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_STAGE_GATES, element: ( <Suspense fallback={<RouteLoader/>}> <StageGates /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RECURRING_TASKS, element: <RecurringTasks /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_TASKS, element: <Task /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_QUERIES, element: <Queries /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RISKS_AND_ISSUES, element: <RiskAndIssues /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_COMMERICIALS, element: <Commercials /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_ARTEFACT_AND_DOCUMENTS, element: <Documents /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_MATERIAL_REQUESTS, element: <MaterialRequests /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RESOURCE_REQUESTS, element: <ResourceRequests /> }],
      },
      {
        element: <AppLayout title="Tasks" />,
        children: [{ path: ROUTES.TASKS, element: <Task /> }],
      },
      {
        element: <AppLayout title="Queries" />,
        children: [{ path: ROUTES.QUERIES, element: <Queries /> }],
      },
      {
        element: <AppLayout title="Risk Dashboard" />,
        children: [{ path: ROUTES.RISK_DASHBOARD, element: <RiskAndIssues /> }],
      },
      {
        element: <AppLayout title="Meeting Manager" />,
        children: [{ path: ROUTES.MEETING_MANAGER, element: ( <Suspense fallback={<RouteLoader/>}> <MeetingManager /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Documents" />,
        children: [{ path: ROUTES.DOCUMENT_MANAGER, element: <Documents /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_ARTEFACT_AND_DOCUMENTS, element: <Documents /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_MATERIAL_REQUESTS, element: <MaterialRequests /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_RESOURCE_REQUESTS, element: <ResourceRequests /> }],
      },
      {
        element: <AppLayout title="Tracking Pipeline" />,
        children: [{ path: ROUTES.REQUESTS_PIPELINE, element: ( <Suspense fallback={<RouteLoader/>}> <Procurement /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Jeopardy Manager" />,
        children: [{ path: ROUTES.JEOPARDY_MANAGER, element: ( <Suspense fallback={<RouteLoader/>}> <Jeopardy /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Jeopardy Details" />,
        children: [{ path: ROUTES.JEOPARDY_MANAGER_DETAILS, element: ( <Suspense fallback={<RouteLoader/>}> <JeopardyDetail /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Contractor Oversight" />,
        children: [{ path: ROUTES.CONTRACTOR_OVERSIGHT, element: ( <Suspense fallback={<RouteLoader/>}> <ContractorOversight /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Commercial Programme Dashboard" />,
        children: [{ path: ROUTES.COMMERCIAL_DASHBOARD, element: ( <Suspense fallback={<RouteLoader/>}> <CommercialsDashboard /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Budgets vs Actuals" />,
        children: [{ path: ROUTES.BUDGETS_VS_ACTUALS, element: ( <Suspense fallback={<RouteLoader/>}> <BudgetCastPerformance /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Commitments & Accruals" />,
        children: [{ path: ROUTES.COMMITMENTS_AND_ACCRUALS, element: ( <Suspense fallback={<RouteLoader/>}> <CommitmentsExposure /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Trends & Forecasts" />,
        children: [{ path: ROUTES.TRENDS_AND_FORECASTS, element: ( <Suspense fallback={<RouteLoader/>}> <TrendsForecast /> </Suspense> ) }],
      },
      {
        element: <AppLayout title="Import Manager" />,
        children: [{ path: ROUTES.IMPORT_MANAGER, element: ( <Suspense fallback={<RouteLoader/>}> <Import /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Import Batch Details" />,
        children: [{ path: ROUTES.IMPORT_BATCH_DETAIL, element: ( <Suspense fallback={<RouteLoader/>}> <BatchDetail /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Export" />,
        children: [{ path: ROUTES.EXPORT_MANAGER, element: ( <Suspense fallback={<RouteLoader/>}> <Export /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Vision Studio" />,
        children: [{ path: ROUTES.VISION_STUDIO, element: ( <Suspense fallback={<RouteLoader/>}> <VisionStudio /> </Suspense>) }],
      }
    ],
  },
];
